import React, { useEffect, useState } from "react";
import styles from "./statistic.module.css";
import StatisticFormat from "components/statisticFormat/statisticFormat";
import { statistic4 } from "services/statistic/statistic4";
import { downloadFile, generateCSVContent, weekDays } from "utils/statistic";
import { BlockDayFacultyData } from "modules/statistic";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import ErrorFailed from "components/errorFailed/errorFailed";
import Popup from "components/Popup/popup";

export default function Statistic4() {
  const [blockData, setBlockData] = useState<BlockDayFacultyData>({});
  const [error, setError] = useState<string | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minYear, setMinYear] = useState<number | null>(null);
  const [maxYear, setMaxYear] = useState<number | null>(null);
  const fetchData = async () => {
    try {
      const res = await statistic4(startDate, endDate);

      const block_data = res.data;
      setBlockData(block_data);
      let allYears: number[] = [];

      Object.entries(block_data).forEach(([block, years]) => {
        Object.entries(years as { [year: number]: { days: { [day: string]: number }; total: number } }).forEach(([year, data]) => {
          allYears.push(Number(year));
        });
      });

      if (allYears.length > 0) {
        setMinYear(Math.min(...allYears));
        setMaxYear(Math.max(...allYears));
      }

    } catch (error) {
      console.error("Fehler beim Laden der Daten:", error);
    }
  };

  const handleFilter = () => {
    if (!startDate || !endDate) {
      setError("Bitte geben Sie sowohl ein Startdatum als auch ein Enddatum ein.");
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      setError("Das Startdatum kann nicht nach dem Enddatum liegen.");
      return;
    }

    setIsPopupOpen(false);
    setError(null);
    setIsPopupOpen(false);
    fetchData();
  };

  const handleDeleteFilter = () => {
    setStartDate('');
    setEndDate('');
    setError(null)
    setIsPopupOpen(false);
  };

  const downloadCSV = () => {
    const headers = ['Block', ...weekDays, 'Gesamt', 'Jahr'];
    const rows: (string | number)[][] = [];

    sortedBlocks.forEach(([block, years]) => {
      Object.entries(years)
        .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
        .forEach(([year, data]) => {
          const row = [
            block,
            ...weekDays.map((day) => {
              const totalForDay = data.days[day]?.total;
              return totalForDay ? Number(totalForDay) : 0;
            }),
            Number(data.total) || 0,
            year
          ];
          rows.push(row);
        });
    });

    const csvContent = generateCSVContent(headers, rows);
    downloadFile(csvContent, "Anlage2b.csv");
  };

  useEffect(() => {
    fetchData();
  }, [isPopupOpen]);

  const sortedBlocks = Object.entries(blockData).sort(([blockA], [blockB]) => {
    return blockA.localeCompare(blockB);
  });

  return (
    <>
      <StatisticFormat
        label="Anlage 2b"
        description={startDate && endDate
          ? `Belegungszahlen der "Flexi" im Zeitraum vom ${startDate} bis ${endDate} Anzahl der Buchungen nach Wochentagen und Blöcken (Montag bis Freitag)  nach Fakultäten.`
          : `Belegungszahlen der "Flexi" im Zeitraum vom 01.01.${minYear} bis 31.12.${maxYear} Anzahl der Buchungen nach Wochentagen und Blöcken (Montag bis Freitag)  nach Fakultäten.`
        } onButton1Click={downloadCSV}
        onFilterButton1Click={() => setIsPopupOpen(true)}

      >
        <div className={styles.container}>
          <table className={styles.table}>
            <thead>
              <tr className={styles.gesamt}>
                <th>Block</th>
                {weekDays.map((day) => (
                  <th key={day}>{day}</th>
                ))}
                <th>Gesamt</th>
                <th>Jahr</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.emptyRowNoBorder}>
                <td colSpan={8}></td>
              </tr>
              {sortedBlocks.map(([block, years]) => (
                <React.Fragment key={block}>
                  {Object.entries(years)
                    .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
                    .map(([year, data], yearIndex) => {
                      const currentYear = Math.max(...Object.keys(years).map(Number));
                      return (
                        <React.Fragment key={`${block}-${year}`}>
                          <tr className={styles[`year-${(currentYear - parseInt(year)) % 9 + 1}`]}>
                            <td>{yearIndex === 0 ? block : ''}</td>

                            {weekDays.map((day) => (
                              <td key={day}>{data.days[day]?.total || 0}</td>
                            ))}
                            <td>{data.total}</td>
                            <td>{year}</td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  <tr className={styles.emptyRow}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <td key={`empty-cell-${index}`}></td>
                    ))}
                  </tr>
                  {Object.entries(years)
                    .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
                    .map(([year, data], yearIndex) => {
                      const currentYear = Math.max(...Object.keys(years).map(Number));
                      return (
                        <React.Fragment key={`${block}-${year}`}>
                          <tr className={styles[`year-${(currentYear - parseInt(year)) % 9 + 1}`]}>

                            <td>{yearIndex === 0 ? 'davon Alter U1' : ''}</td>

                            {weekDays.map((day) => (
                              <td key={day}>{data.days[day]?.under_one_year || 0}</td>
                            ))}
                            <td>{data.under_one_year}</td>
                            <td>{year}</td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  <tr className={styles.emptyRow}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <td key={`empty-cell-${index}`}></td>
                    ))}
                  </tr>
                  {Object.entries(years)
                    .map(([year, yearData]) => {
                      const currentYear = Math.max(...Object.keys(years).map(Number));
                      const facultiesList = Object.entries(yearData.faculties);
                      return facultiesList.map(([faculty, facultyCount]) => (
                        <React.Fragment key={`${block}-${faculty}`}>
                          {Object.entries(years).sort(([yearA], [yearB]) => Number(yearB) - Number(yearA)).map(([year, yearData], yearIndex) => (
                            <React.Fragment key={`${block}-${faculty}-${year}`}>
                              <tr className={styles[`year-${(currentYear - parseInt(year)) % 9 + 1}`]}>
                                <td>{yearIndex === 0 ? faculty : ''}</td>
                                {weekDays.map((day) => (
                                  <td key={day}>{yearData.days[day]?.faculties[faculty] || 0}</td>
                                ))}
                                <td>{yearData.faculties[faculty]}</td>
                                <td>{year}</td>
                              </tr>
                            </React.Fragment>
                          ))}
                          <tr className={styles.emptyRow}>
                            {Array.from({ length: 8 }).map((_, index) => (
                              <td key={`empty-cell-${index}`}></td>
                            ))}
                          </tr>
                        </React.Fragment>
                      ));
                    })}

                  <tr className={styles.emptyRowNoBorder}>
                    <td colSpan={8}></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </StatisticFormat>
      <Popup
        title={'Filter'}
        submitLabel={"Einsetzen"}
        closeLabel={"Zurücksetzen"}
        isWithButton={true}
        isOpen={isPopupOpen}
        onClose={handleDeleteFilter} onSubmit={handleFilter}>
        {error && <ErrorFailed error={error} />}

        <div className={commonStyles.formGroupRow}>
          <div className={commonStyles.formGroup}>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className={commonStyles.formGroup}>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </Popup>
    </>
  );
}